package org.multipaz.wallet.shared

class WalletBackendIdTokenException(message: String? = null): WalletBackendException(message)